import React, { useCallback, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import api from '../../services/api';

import { useAlert } from '../../hooks/alert';

import Input from '../../components/Input';
import getValidationErrors from '../../utils/getValidationErrors';
import Select from '../../components/Select';

const Register: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const [loading, setLoading] = useState(false);

  const { showAlert } = useAlert();
  const history = useHistory();

  const handleSubmit = useCallback(
    async (data: object) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          agency: Yup.string().required('Informe se pertence à uma agência'),
          name: Yup.string().required('Digite seu nome completo'),
          company: Yup.string().required('Digite a razão social'),
          email: Yup.string()
            .required('Digite seu e-mail')
            .email('Digite um e-mail válido'),
          phone: Yup.string().required('Digite seu telefone'),
          cnpj: Yup.string().required('Digite o CNPJ'),
          password: Yup.string()
            .required('Digite sua senha')
            .min(6, 'No mínimo 6 dígitos'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post('user', data);

        showAlert({
          type: 'success',
          title: 'Cadastro realizado com sucesso',
          description:
            'Aguarde nosso e-mail de aprovação para prosseguir com a navegação. Obrigado.',
        });

        history.push('login');
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
        } else {
          showAlert({
            type: 'error',
            title: 'Algum erro aconteceu',
            description: 'Verifique os dados obrigatórios e tente novamente.',
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [history, showAlert],
  );

  return (
    <>
      <Form onSubmit={handleSubmit} ref={formRef}>
        <h5 className="spacer">CADASTRO</h5>

        <p>
          Lorem ipsum dolor sit amet, qui minim labore adipisicing minim sint
          cillum sint consectetur cupidatat.
        </p>

        <div className="spacer" />

        <div className="form-group">
          <label htmlFor="name">SEU NOME COMPLETO</label>
          <Input name="name" type="text" className="form-control" id="name" />
        </div>

        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="company">RAZÃO SOCIAL</label>
              <Input
                name="company"
                type="text"
                className="form-control"
                id="company"
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="agency">AGÊNCIA?</label>
              <Select name="agency" className="form-control" id="agency">
                <option value="">Selecione</option>
                <option value="S">Sim</option>
                <option value="N">Não</option>
              </Select>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="email">E-MAIL</label>
              <Input
                name="email"
                type="text"
                className="form-control"
                id="email"
              />
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="password">SENHA</label>
              <Input
                name="password"
                type="password"
                className="form-control"
                id="password"
              />
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="cnpj">CNPJ</label>
              <Input
                name="cnpj"
                type="text"
                className="form-control"
                id="cnpj"
              />
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="phone">TELEFONE</label>
              <Input
                name="phone"
                type="text"
                className="form-control"
                id="phone"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-sm-6">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'CARREGANDO...' : 'CADASTRAR'}
            </button>
          </div>
          <div className="col-12 col-sm-6 d-flex align-items-center align-items-sm-end justify-content-center flex-column">
            <div className="p-4 p-sm-0">
              <Link to="login">Já tenho cadastro</Link>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
};

export default Register;
